import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ContentProvider } from "@/context/ContentContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Plans from "@/pages/Plans";
import Contact from "@/pages/Contact";
import OrderSim from "@/pages/OrderSim";
import PortNumber from "@/pages/PortNumber";
import Regulamin from "@/pages/Regulamin";
import Rodo from "@/pages/Rodo";
import MapPreview from "@/pages/MapPreview";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import CookiePolicy from "@/pages/CookiePolicy";
import InternetMobilny from "@/pages/InternetMobilny";
import { ADMIN_PATH } from "@/lib/adminPath";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ContentProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/abonamenty" element={<Plans />} />
              <Route path="/internet-mobilny" element={<InternetMobilny />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/zamow-sim" element={<OrderSim />} />
              <Route path="/przenies-numer" element={<PortNumber />} />
              <Route path="/regulamin" element={<Regulamin />} />
              <Route path="/rodo" element={<Rodo />} />
              <Route path="/mapa-podglad" element={<MapPreview />} />
              <Route path="/polityka-cookies" element={<CookiePolicy />} />
              <Route path="/platnosc/sukces" element={<PaymentSuccess />} />
              <Route path="/platnosc/anulowano" element={<PaymentCancel />} />
              <Route path={`/${ADMIN_PATH}/login`} element={<AdminLogin />} />
              <Route path={`/${ADMIN_PATH}`} element={<AdminDashboard />} />
            </Route>
          </Routes>
        </ContentProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
